import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=349fefb4&scoped=true"
import script from "./AccountSetup.vue?vue&type=script&lang=js"
export * from "./AccountSetup.vue?vue&type=script&lang=js"
import style0 from "./AccountSetup.vue?vue&type=style&index=0&id=349fefb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349fefb4",
  null
  
)

export default component.exports